import React from "react";
import PropTypes from "prop-types";

/**
 * Componente CommonInputDecimal
 *
 * @component
 * @param {Object} props - As propriedades do componente.
 * @param {string} props.label - O rótulo do input.
 * @param {string} props.id - O identificador exclusivo do input.
 * @param {string} props.value - O valor atual do input.
 * @param {Function} props.onChange - A função a ser chamada quando o valor do input muda.
 * @param {boolean} [props.required=false] - Um sinalizador que indica se o input é obrigatório.
 * @param {boolean} [props.disabled=false] - Um sinalizador que indica se o input está desabilitado.
 * @param {Object} [props...rest] - Propriedades adicionais a serem passadas para o input.
 * @returns {ReactElement} O elemento React renderizado que representa o campo de input decimal.
 */
function CommonSwitch({
  label,
  id,
  value,
  onChange,
  required = false,
  disabled = false,
  ...props
}) {
  return (
    <>
      <label
        htmlFor={id}
        className={`form-label ${required ? "requiredInput" : ""}`}
      >
        {label}
      </label>
      <div className="form-check form-switch mb-3">
        <input
          className="form-check-input"
          type="checkbox"
          id={id}
          name={id}
          checked={value}
          onChange={disabled ? null : onChange}
          disabled={disabled}
          {...props}
        />
      </div>
    </>
  );
}

CommonSwitch.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default CommonSwitch;
